var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFieldPreviewIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 3.24219C9.55228 3.24219 10 2.79447 10 2.24219C10 1.6899 9.55228 1.24219 9 1.24219C8.44772 1.24219 8 1.6899 8 2.24219C8 2.79447 8.44772 3.24219 9 3.24219Z",
    stroke: "#2A2B28",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 10.2422C9.55228 10.2422 10 9.79447 10 9.24219C10 8.6899 9.55228 8.24219 9 8.24219C8.44772 8.24219 8 8.6899 8 9.24219C8 9.79447 8.44772 10.2422 9 10.2422Z",
    stroke: "#2A2B28",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 17.2422C9.55228 17.2422 10 16.7945 10 16.2422C10 15.6899 9.55228 15.2422 9 15.2422C8.44772 15.2422 8 15.6899 8 16.2422C8 16.7945 8.44772 17.2422 9 17.2422Z",
    stroke: "#2A2B28",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 3.24219C16.5523 3.24219 17 2.79447 17 2.24219C17 1.6899 16.5523 1.24219 16 1.24219C15.4477 1.24219 15 1.6899 15 2.24219C15 2.79447 15.4477 3.24219 16 3.24219Z",
    stroke: "#2A2B28",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 10.2422C16.5523 10.2422 17 9.79447 17 9.24219C17 8.6899 16.5523 8.24219 16 8.24219C15.4477 8.24219 15 8.6899 15 9.24219C15 9.79447 15.4477 10.2422 16 10.2422Z",
    stroke: "#2A2B28",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 17.2422C16.5523 17.2422 17 16.7945 17 16.2422C17 15.6899 16.5523 15.2422 16 15.2422C15.4477 15.2422 15 15.6899 15 16.2422C15 16.7945 15.4477 17.2422 16 17.2422Z",
    stroke: "#2A2B28",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2 3.24219C2.55228 3.24219 3 2.79447 3 2.24219C3 1.6899 2.55228 1.24219 2 1.24219C1.44772 1.24219 1 1.6899 1 2.24219C1 2.79447 1.44772 3.24219 2 3.24219Z",
    stroke: "#2A2B28",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2 10.2422C2.55228 10.2422 3 9.79447 3 9.24219C3 8.6899 2.55228 8.24219 2 8.24219C1.44772 8.24219 1 8.6899 1 9.24219C1 9.79447 1.44772 10.2422 2 10.2422Z",
    stroke: "#2A2B28",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2 17.2422C2.55228 17.2422 3 16.7945 3 16.2422C3 15.6899 2.55228 15.2422 2 15.2422C1.44772 15.2422 1 15.6899 1 16.2422C1 16.7945 1.44772 17.2422 2 17.2422Z",
    stroke: "#2A2B28",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFieldPreviewIcon);
export default __webpack_public_path__ + "static/media/field_preview_Icon.b4c3b916da515c3b552a1dcd9b95f638.svg";
export { ForwardRef as ReactComponent };